<div class="h-screen relative overflow-hidden flex flex-col justify-between bg-[#f5f5f7] dark:bg-[#050505] text-slate-900 dark:text-gray-100 transition-colors duration-500 text-[14px] leading-normal antialiased selection:bg-indigo-500/30">

  <!-- Navigation -->
  <nav class="fixed top-0 w-full z-50 bg-[#f5f5f7]/90 dark:bg-[#0a0a0a]/80 backdrop-blur-xl border-b border-gray-200 dark:border-white/5 transition-all duration-300">
    <div class="w-full px-6 h-[64px] flex items-center justify-between">
      <div class="flex items-center gap-4 group">
        <div class="w-8 h-8 rounded-lg bg-slate-900 dark:bg-white text-white dark:text-black flex items-center justify-center shadow-sm">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6.429 9.75 2.25 12l4.179 2.25m0-4.5 5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0 4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0-5.571 3-5.571-3" />
          </svg>
        </div>
        <div class="flex items-center gap-3">
          <span class="text-gray-300 dark:text-gray-700 font-light text-xl">/</span>
          <span class="font-sans font-medium text-[15px] tracking-tight text-slate-900 dark:text-white">Survey Questions</span>
        </div>
      </div>
      
      <div class="flex items-center gap-6">
        <!-- Theme Toggles -->
        <div class="flex items-center p-1 rounded-full bg-gray-100/80 dark:bg-white/5 border border-gray-200/50 dark:border-white/5 backdrop-blur-md">
          <button (click)="setTheme('light')" [ngClass]="{'text-indigo-600 bg-white shadow-sm': currentTheme === 'light'}" class="p-1.5 rounded-full text-gray-400 hover:text-gray-900 dark:hover:text-white transition-all duration-200 hover:bg-white dark:hover:bg-white/10">
            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" />
            </svg>
          </button>
          <button (click)="setTheme('dark')" [ngClass]="{'shadow-sm': currentTheme === 'dark'}" class="p-1.5 rounded-full text-gray-400 hover:text-gray-900 dark:hover:text-white transition-all duration-200 hover:bg-white dark:hover:bg-white/10">
            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z" />
            </svg>
          </button>
        </div>

        <div class="hidden md:flex items-center gap-6">
          <a routerLink="/analysis-report" class="text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 font-medium text-[13px] transition-colors">
            Photo QC Analysis
          </a>
          <button (click)="goToDocumentation()" class="text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 font-medium text-[13px] transition-colors cursor-pointer">
            Documentation
          </button>
        </div>
      </div>
    </div>
  </nav>

  <!-- Main Content -->
  <main class="relative z-10 pt-[64px] w-full h-full flex flex-col flex-grow overflow-hidden transition-colors duration-500">
    
    <div class="w-full max-w-7xl fade-in mx-auto h-full overflow-y-auto hide-scroll pb-24 px-8 pt-10">
      
      <!-- Back Button -->
      <button (click)="goBack()" class="flex items-center gap-2 text-gray-500 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 mb-6 transition-colors group">
        <svg class="w-4 h-4 group-hover:-translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
        </svg>
        <span class="text-sm font-medium">Back to Photo QC Analysis</span>
      </button>

      <!-- Dashboard Card -->
      <div class="bg-white dark:bg-[#0d0d0d]/80 dark:backdrop-blur-xl rounded-3xl overflow-hidden shadow-[0_8px_40px_-12px_rgba(0,0,0,0.1)] dark:shadow-[0_8px_40px_-8px_rgba(0,0,0,0.5)] border border-gray-100/80 dark:border-white/[0.06] transition-all duration-300">
        
        <!-- Header -->
        <div class="relative px-8 py-6 border-b border-gray-100/80 dark:border-white/[0.06]">
          <!-- Stats Row -->
          <div class="flex items-center gap-4 mb-4">
            <span class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-indigo-50 dark:bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 text-xs font-semibold">
              <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
              </svg>
              {{ filteredQuestions.length }} Questions
            </span>
            <span class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-slate-100 dark:bg-slate-500/10 text-slate-600 dark:text-slate-400 text-xs font-semibold">
              <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 8.25h15m-16.5 7.5h15m-1.8-13.5-3.9 19.5m-2.1-19.5-3.9 19.5" />
              </svg>
              Template ID: {{ templateId }}
            </span>
          </div>
          
          <div class="mb-5">
            <h1 class="text-2xl font-bold text-gray-900 dark:text-white tracking-tight">Survey Questions</h1>
            <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">{{ templateName }}</p>
          </div>
          
          <!-- Confidence Score Legend - Right Aligned -->
          <div class="flex justify-end mb-5">
            <div class="flex items-center gap-6">
              <div class="flex items-center gap-2">
                <span class="w-3 h-3 rounded-full bg-emerald-500"></span>
                <span class="text-sm text-gray-600 dark:text-gray-400">≥85%</span>
              </div>
              <div class="flex items-center gap-2">
                <span class="w-3 h-3 rounded-full bg-amber-500"></span>
                <span class="text-sm text-gray-600 dark:text-gray-400">70-84%</span>
              </div>
              <div class="flex items-center gap-2">
                <span class="w-3 h-3 rounded-full bg-red-500"></span>
                <span class="text-sm text-gray-600 dark:text-gray-400">&lt;70%</span>
              </div>
            </div>
          </div>
          
          <!-- Search Input -->
          <div class="relative">
            <svg class="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
            </svg>
            <input 
              type="text" 
              [(ngModel)]="searchQuery"
              placeholder="Search questions..."
              class="w-full pl-11 pr-4 py-3 rounded-xl bg-gray-50 dark:bg-white/5 border border-gray-200/80 dark:border-white/10 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500/50 transition-all text-sm"
            />
          </div>
        </div>

        <!-- Table Header (Sortable) -->
        <div class="grid grid-cols-[1fr_100px] items-center px-8 py-4 bg-gray-50/60 dark:bg-white/[0.02] border-b border-gray-100/60 dark:border-white/[0.04]">
          <button (click)="toggleSort('name')" class="flex items-center gap-1.5 text-[11px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-[0.08em] hover:text-gray-600 dark:hover:text-gray-300 transition-colors text-left">
            Question / Prompts
            <svg *ngIf="sortColumn === 'name'" class="w-3 h-3" [class.rotate-180]="sortDirection === 'desc'" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" />
            </svg>
          </button>
          <button (click)="toggleSort('confidenceScore')" class="flex items-center justify-center gap-1.5 text-[11px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-[0.08em] hover:text-gray-600 dark:hover:text-gray-300 transition-colors">
            Confidence
            <svg *ngIf="sortColumn === 'confidenceScore'" class="w-3 h-3" [class.rotate-180]="sortDirection === 'desc'" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" />
            </svg>
          </button>
        </div>

        <!-- Loading State -->
        <div *ngIf="isLoading" class="flex flex-col items-center justify-center py-20">
          <div class="relative">
            <div class="w-14 h-14 rounded-full border-[3px] border-gray-100 dark:border-gray-800"></div>
            <div class="absolute top-0 left-0 w-14 h-14 rounded-full border-[3px] border-transparent border-t-indigo-500 animate-spin"></div>
          </div>
          <p class="mt-5 text-sm text-gray-500 dark:text-gray-400 font-medium">Loading questions...</p>
        </div>

        <!-- Questions List -->
        <div *ngIf="!isLoading" class="divide-y divide-gray-100/60 dark:divide-white/[0.04]">
          
          <!-- Empty State -->
          <div *ngIf="filteredQuestions.length === 0" class="flex flex-col items-center justify-center py-20 px-8">
            <div class="w-20 h-20 rounded-2xl bg-gradient-to-br from-gray-100 to-gray-50 dark:from-white/10 dark:to-white/5 flex items-center justify-center mb-5 shadow-inner">
              <svg class="w-10 h-10 text-gray-300 dark:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
              </svg>
            </div>
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">No Questions Found</h3>
            <p class="text-sm text-gray-500 dark:text-gray-400 text-center max-w-md">
              No questions are available for this template.
            </p>
          </div>

          <!-- Question Items -->
          <div *ngFor="let question of filteredQuestions; let i = index" 
               (click)="question.hasAnalysisData ? viewQuestionDetails(question) : null"
               class="relative grid grid-cols-[1fr_100px] items-start px-8 py-6 group transition-all duration-300"
               [ngClass]="{
                 'bg-gray-50/40 dark:bg-white/[0.02]': i % 2 === 0,
                 'hover:bg-gradient-to-r hover:from-indigo-50/50 hover:to-transparent dark:hover:from-indigo-500/5 dark:hover:to-transparent cursor-pointer': question.hasAnalysisData,
                 'opacity-60 cursor-not-allowed': !question.hasAnalysisData
               }">
            
            <!-- Custom Tooltip for disabled rows -->
            <div *ngIf="!question.hasAnalysisData" 
                 class="absolute left-1/2 -translate-x-1/2 top-2 z-50 px-3 py-1.5 bg-gray-900 dark:bg-gray-700 text-white text-xs font-medium rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap">
              No QA analysis ran yet
              <div class="absolute left-1/2 -translate-x-1/2 top-full w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-gray-900 dark:border-t-gray-700"></div>
            </div>
            
            <!-- Question & Prompts Column -->
            <div class="flex-1 min-w-0 space-y-3">
              <!-- Question ID and Name -->
              <div>
                <span class="text-xs text-gray-400 dark:text-gray-500 font-medium">{{ question.id }}</span>
                <p class="text-[15px] font-medium text-gray-800 dark:text-gray-100 leading-relaxed mt-1">{{ question.name }}</p>
              </div>
              
              <!-- Prompts display -->
              <div class="mt-2" *ngIf="question.prompts">
                <p class="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">{{ question.prompts }}</p>
              </div>
              <div class="mt-2" *ngIf="!question.prompts">
                <span class="text-xs text-gray-400 dark:text-gray-500 italic">No prompts configured</span>
              </div>
            </div>
            
            <!-- Confidence Donut Chart (when has analysis data) -->
            <div *ngIf="question.hasAnalysisData" class="flex justify-center pt-1">
              <div class="relative w-16 h-16 group-hover:scale-110 transition-transform duration-300">
                <div class="w-full h-full rounded-full shadow-lg" 
                     [style.background]="currentTheme === 'dark' ? getDonutStyleDark(question.confidenceScore) : getDonutStyle(question.confidenceScore)">
                </div>
                <div class="absolute inset-[6px] rounded-full bg-white dark:bg-[#0d0d0d] flex items-center justify-center shadow-inner">
                  <span class="text-[10px] font-bold" [style.color]="getScoreColor(question.confidenceScore)">
                    {{ getConfidenceLabel(question.confidenceScore) }}
                  </span>
                </div>
              </div>
            </div>
            
            <!-- No Analysis Data Indicator -->
            <div *ngIf="!question.hasAnalysisData" class="flex justify-center pt-1">
              <div class="relative w-16 h-16 group" title="QA analysis has not been run yet">
                <div class="w-full h-full rounded-full bg-gray-200 dark:bg-gray-700/50 border-2 border-dashed border-gray-300 dark:border-gray-600 flex items-center justify-center">
                  <svg class="w-6 h-6 text-gray-400 dark:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                  </svg>
                </div>
                <span class="absolute -bottom-5 left-1/2 -translate-x-1/2 text-[9px] text-gray-400 dark:text-gray-500 whitespace-nowrap font-medium">Pending</span>
              </div>
            </div>
          </div>

        </div>
        
      </div>

    </div>
  </main>

</div>
